import PropTypes from 'prop-types';
import { path } from 'ramda';
import { connect } from 'react-redux';
import { readEndpoint } from 'redux-json-api';
import React, { Component } from 'react';

import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { DirectionsBus } from '@material-ui/icons';
import blue from '@material-ui/core/es/colors/blue';
import green from '@material-ui/core/es/colors/green';
import grey from '@material-ui/core/es/colors/grey';
import red from '@material-ui/core/es/colors/red';

import { routeBlockageDetailOpen } from '../../modules/actions/routeBlockageDetail';


class RouteBlockage extends Component {
  static propTypes = {
    // Own props.
    routeBlockage: PropTypes.shape({
      id: PropTypes.string.isRequired,
      attributes: PropTypes.shape({
        'invited-drivers-accepted': PropTypes.number.isRequired,
        'rides-km-zero': PropTypes.number.isRequired,
        'rides-km-one': PropTypes.number.isRequired,
        'rides-km-two': PropTypes.number.isRequired,
        'rides-km-three': PropTypes.number.isRequired,
        'rides-km-four': PropTypes.number.isRequired,
      }).isRequired,
      relationships: PropTypes.shape({
        'stop-from': PropTypes.shape({ data: PropTypes.shape({ id: PropTypes.string.isRequired }).isRequired }).isRequired,
        'stop-to': PropTypes.shape({ data: PropTypes.shape({ id: PropTypes.string.isRequired }).isRequired }).isRequired,
      }).isRequired,
    }).isRequired,
    routeBlockageNames: PropTypes.shape({}).isRequired,

    // Dispatch props.
    readEndpoint: PropTypes.func.isRequired,
    routeBlockageDetailOpen: PropTypes.func.isRequired,
  };

  shouldComponentUpdate(nextProps, nextState) {
    return true;
  };

  render() {
    const {
      routeBlockage,
      routeBlockageNames,
      routeBlockageDetailOpen,
    } = this.props;

    const routeBlockageName = routeBlockageNames[String(routeBlockage.id)] || 'Onbekend';
    const vehicleCount = path(['attributes', 'vehicles-required'], routeBlockage) || 0;

    // Rides with two distance counts are shuttling.
    const greenCount = routeBlockage.attributes['rides-km-two'];

    // Rides with one distance count are on their way to the route blockage.
    const redCount = routeBlockage.attributes['rides-km-one'];

    // Invited drivers who have accepted, or rides with no distance counts,
    // have reserved slots.
    const blueCount = routeBlockage.attributes['invited-drivers-accepted'] + routeBlockage.attributes['rides-km-zero'];

    let icons = [];

    for (let i = 0; i < greenCount; i++) {
      icons.push((
        <DirectionsBus
          key={'route-blockage-' + routeBlockage.id + '-icon-' + i}
          style={{ color: green[800], fill: green[800], height: 16, width: 16 }}
        />
      ));
    }

    for (let i = greenCount; i < (greenCount + redCount); i++) {
      icons.push((
        <DirectionsBus
          key={'route-blockage-' + routeBlockage.id + '-icon-' + i}
          style={{ color: red[800], fill: red[800], height: 16, width: 16 }}
        />
      ));
    }

    for (let i = (greenCount + redCount); i < (greenCount + redCount + blueCount); i++) {
      icons.push((
        <DirectionsBus
          key={'route-blockage-' + routeBlockage.id + '-icon-' + i}
          style={{ color: blue[800], fill: blue[800], height: 16, width: 16 }}
        />
      ));
    }

    for (let i = (greenCount + redCount + blueCount); i < vehicleCount; i++) {
      icons.push((
        <DirectionsBus
          key={'route-blockage-' + routeBlockage.id + '-icon-' + i}
          style={{ color: grey[300], fill: grey[300], height: 16, width: 16 }}
        />
      ));
    }

    return (
      <ListItem
        button
        alignItems="flex-start"
        onClick={(event) => {
          routeBlockageDetailOpen(routeBlockage.id);

          event.stopPropagation();
          event.preventDefault();
        }}
      >
        <ListItemText
          primary={routeBlockageName}
          secondary={icons}
        />
      </ListItem>
    );
  };
}

const mapDispatchToProps = {
  readEndpoint,
  routeBlockageDetailOpen,
};

export default connect(null, mapDispatchToProps)(RouteBlockage);
